const SelectTime = ({ times, selectedTime, setSelectedTime }) => {
    return (
        <select
            id='choice-select'
            className='choice-select'
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
        >
            {times.map((time) => (
                <option
                    key={time}
                    value={time}
                >
                    {time}
                </option>
            ))}
        </select>
    );
};

export default SelectTime;